module.exports = __webpack_public_path__ + "img/R5_research.74d80667.png";